import _ from 'lodash';

import { formatPhoneNumberForDisplay } from 'utils/phone';

export const transformRealtor = ({
  firstName,
  lastName,
  emailAddress,
  phoneNumber,
  assignedLoanOfficer,
  connectedLoanOfficer,
  ...rest
}) => ({
  firstName: firstName?.trim(),
  lastName: lastName?.trim(),
  emailAddress: emailAddress?.trim(),
  phoneNumber: formatPhoneNumberForDisplay(phoneNumber),
  isLoanOfficer: false,
  assignedLoanOfficer,
  connectedLoanOfficer,
  assignedLoanOfficerFullName: assignedLoanOfficer
    ? `${assignedLoanOfficer.firstName} ${assignedLoanOfficer.lastName}`
    : null,
  ...rest,
});

export const transformRealtors = ({ normalizedRealtors, LORealtors }) => {
  const transformedRealtors = _.mapValues(normalizedRealtors, transformRealtor);

  _.forEach(LORealtors, ({ id }) => {
    transformedRealtors[id].isLoanOfficer = true;
  });

  return transformedRealtors;
};
